import React, { ReactNode } from "react";

import "./Overlay.scss";

export default function Overlay({ children }: { children?: ReactNode }) {
    return <div className="bwp-overlay">{children}</div>;
}
